import { TrialCardIcon } from '@chiroup/core/types/TrialHome.type';
import {
  Banknote as BanknotesIcon,
  BookOpen as BookOpenIcon,
  CalendarDays as CalendarDaysIcon,
  ChartBar as ChartBarIcon,
  ClipboardCheck as ClipboardDocumentCheckIcon,
  FileText as DocumentTextIcon,
  Megaphone as MegaphoneIcon,
  Send as PaperAirplaneIcon,
  Puzzle as PuzzlePieceIcon,
  Rocket as RocketLaunchIcon,
  Sparkles as SparklesIcon,
  Video as VideoCameraIcon,
} from 'lucide-react';
import React from 'react';

/**
 * Mirror of apps/chiroup/src/components/home/trial/cardIcons.ts kept here so
 * the admin preview renders identical icons without an inter-app import. If
 * you add a new value to {@link TrialCardIcon}, mirror it in both files.
 */
export const TRIAL_CARD_ICON_COMPONENTS: Record<
  TrialCardIcon,
  React.ComponentType<{ className?: string }>
> = {
  'clipboard-check': ClipboardDocumentCheckIcon,
  'book-open': BookOpenIcon,
  'paper-airplane': PaperAirplaneIcon,
  'document-text': DocumentTextIcon,
  calendar: CalendarDaysIcon,
  banknotes: BanknotesIcon,
  sparkles: SparklesIcon,
  'chart-bar': ChartBarIcon,
  rocket: RocketLaunchIcon,
  megaphone: MegaphoneIcon,
  puzzle: PuzzlePieceIcon,
  'video-camera': VideoCameraIcon,
};

export const TRIAL_CARD_ICON_FALLBACK = SparklesIcon;
